export var ApplePayShippingTypesObj = ["shipping", "delivery", "storePickup", "servicePickup"];
/** @internal */
export var validateApplePayShippingType = function (applePayShippingType) {
    return ApplePayShippingTypesObj.includes(applePayShippingType);
};
